import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { Button, Form, InputGroup, Card, Row, Col, Badge } from "react-bootstrap";
import { IconFileDescription } from "@tabler/icons-react";
import { addYears } from "date-fns";
import axios from "axios";
import { toast } from "react-toastify";
import {
  API_ENDPOINTS,
  roundToMoney,
  truncateFormat,
} from "../../../constant/_constant";
import moment from "moment";
import usePostRequest from "../../../hooks/usePostRequest";
import * as yup from "yup";
import { useForm, useFieldArray } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { trimTrailingZeros } from "../../../utils/_helpers";

function PriceChangesModal({
  show,
  setShow,
  rfqid,
  onSuccessFetch,
  triggerCardHighlight,
}) {
  
  const { data: fetchedData, postData: fetchProject } = usePostRequest(
    API_ENDPOINTS.GET_PRICE_CHANGES
  );

  const { isLoading: notesLoading, postData: createPriceChanges } =
    usePostRequest(API_ENDPOINTS.PRICE_CHANGES);

  useEffect(() => {
    fetchProject({ rfq_id: rfqid });
  }, []);

  const data = fetchedData?.data;

  const duration = Number(data?.project_duration);
  const count = isNaN(duration) || duration <= 0 ? 0 : duration;
  const startDate = data?.start_date ? new Date(data.start_date) : new Date();
  const [margin, setMargin] = useState(0);
  const [priceChanges, setPriceChanges] = useState([]);

  useEffect(() => {
    const products = data?.RfqProducts || [];
    const existingChanges = data?.RfqPriceChanges || [];
    const baseDate = data?.start_date ? moment(data.start_date) : moment();
    if (products.length === 0 || count === 0) return;
    const allChanges = [];

    products.forEach((product) => {
      const productSku = product.sku_id;
      const rawSku = product.raw_sku_id;
      const productBasePrice = parseFloat(product.customer_price) || 0;
      const productBaseAspettoPrice = parseFloat(product.aspetto_price) || 0;
      const skuChanges = existingChanges.filter(
        (c) => c.raw_sku_id === rawSku
      );

      // Check if SKU has any existing price changes
      const hasExistingChanges = skuChanges.length > 0;

      for (let yearIndex = 0; yearIndex < count; yearIndex++) {
        const fromDate = baseDate
          .clone()
          .add(yearIndex, "years")
          .format("YYYY-MM-DD");
        const toDate = baseDate
          .clone()
          .add(yearIndex + 1, "years")
          .format("YYYY-MM-DD");

        const existing = skuChanges.find(
          (change) => change.from_date === fromDate && change.to_date === toDate
        );

        if (existing) {
          allChanges.push({
            ...existing,
            customer_price: trimTrailingZeros(existing.customer_price),
            aspetto_price: trimTrailingZeros(existing.aspetto_price),
          });
        } else {
          if (!hasExistingChanges) {
            let price;
            let aspettoPrice;
            if (yearIndex === 0) {
              price = productBasePrice;
              aspettoPrice = productBaseAspettoPrice;
            } else {
              // Calculate margin on previous year price
              const prevPriceChange = allChanges.find(
                (change) =>
                  change.raw_sku_id === rawSku &&
                  change.from_date ===
                    baseDate
                      .clone()
                      .add(yearIndex - 1, "years")
                      .format("YYYY-MM-DD")
              );
              const prevPrice = prevPriceChange
                ? parseFloat(prevPriceChange.customer_price) || 0
                : productBasePrice;
              const prevAspettoPrice = prevPriceChange
                ? parseFloat(prevPriceChange.aspetto_price) || 0
                : productBaseAspettoPrice;
              // price = prevPrice + prevPrice * (margin / 100);
              // aspettoPrice =
              //   prevAspettoPrice + prevAspettoPrice * (margin / 100);
              price = roundToMoney(prevPrice + prevPrice * (margin / 100), 4);
              aspettoPrice = roundToMoney(
                prevAspettoPrice + prevAspettoPrice * (margin / 100),
                4
              );
            }

            allChanges.push({
              sku_id: productSku,
              raw_sku_id: rawSku,
              customer_price: trimTrailingZeros(price),
              aspetto_price: trimTrailingZeros(aspettoPrice),
              margin_percent: margin,
              from_date: fromDate,
              to_date: toDate,
            });
          } else {
            // If there ARE existing price changes,
            // Do NOT fill missing years with price — keep prices blank for manual input
            allChanges.push({
              sku_id: productSku,
              raw_sku_id: rawSku,
              customer_price: "", // keep blank
              aspetto_price: "", // keep blank
              margin_percent: margin,
              from_date: fromDate,
              to_date: toDate,
            });
          }
        }
      }
    });

    setPriceChanges(allChanges);
  }, [data, margin, count]);

  // console.log("data", data)

  const handlePriceChange = (index, field, value) => {
    const updated = [...priceChanges];
    updated[index][field] = trimTrailingZeros(value);
    setPriceChanges(updated);
  };
  const onSuccess = (res) => {
    console.log("res", res?.rfq_id);
    toast.success("Price Changes Updated successfully!");
    setShow({ show: false });
    triggerCardHighlight(res?.rfq_id);
    if (onSuccessFetch) {
      onSuccessFetch();
    }
  };

  const onError = (error) => {
    // const message =
    //     error?.response?.data?.message ||
    //     error?.message ||
    //     "Something went wrong.";
    // toast.error(`Error: ${message}`);
    console.error("Error response:", error);
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!e.target.checkValidity()) {
      e.stopPropagation();
      toast.error("Please fill all required fields.");
      return;
    }
    const payload = {
      rfq_id: data?.rfq_id,
      price_changes: priceChanges,
      opportunity_type: data?.opportunity_type,
      rfq_status: data?.status,
    };
    createPriceChanges(payload, onSuccess, onError);
  };
  return (
  <Modal
  
    show={show}
    onHide={() => setShow({ show: false })}
    className="skusearch"
    dialogClassName="modal-90vw"
    size="xl"
  >
    <Modal.Header closeButton>
            <Row className="align-items-center g-3 w-100">
              <Col md={8}>
                 <Modal.Title>Price Changes</Modal.Title>
                <div className="text-muted small">
                   Manage customer and Aspetto prices year-wise for all products.
                </div>
              </Col>

              <Col md={4} lg={3} className="ms-auto">
                <Form.Group>
                  <Form.Label className="fw-semibold small mb-1">
                    Global Margin %
                  </Form.Label>
                  <InputGroup>
                    <Form.Control
                      type="number"
                      step="0.01"
                      value={margin || ""}
                      onChange={(e) =>
                        setMargin(e.target.value ? parseFloat(e.target.value) : 0)
                      }
                      placeholder="Enter Margin"
                    />
                    <InputGroup.Text>%</InputGroup.Text>
                  </InputGroup>
                </Form.Group>
              </Col>
            </Row>
    </Modal.Header>

    <Form onSubmit={handleSubmit}>
      <Modal.Body style={{ background: "#f8f9fb" }}>

        {!data?.project_duration ? (
          <div className="alert alert-warning mb-0">
            ⚠️ Project duration is not set.
          </div>
        ) : !data?.RfqProducts?.length ? (
          <div className="alert alert-info mb-0">
            ℹ No products available to show.
          </div>
        ) : (
          data?.RfqProducts?.map((product) => {
            const productPriceChanges = priceChanges.filter(
              (p) => p.raw_sku_id === product.raw_sku_id
            );

            return (
              <Card className="border-0 shadow-sm mb-3" key={product.skuId}>
                <Card.Header
                  className="bg-white border-0 py-3"
                  style={{ borderBottom: "1px solid #edf0f3" }}
                >
                  <div className="d-flex gap-2 align-items-start">
                    <div
                      className="d-flex align-items-center justify-content-center rounded"
                      style={{
                        width: 34,
                        height: 34,
                        background: "#eef3ff",
                        color: "#52677a",
                        flexShrink: 0,
                      }}
                    >
                      <IconFileDescription size={20} />
                    </div>

                    <div className="w-100">
                      <div className="d-flex flex-wrap align-items-center gap-2">
                        <div className="fw-semibold text-dark">
                          {product?.sku_display_name}
                        </div>

                        {product?.Vendor?.display_name && (
                          <Badge bg="light" text="dark" className="border">
                            {product?.Vendor?.display_name}
                          </Badge>
                        )}
                      </div>

                      {product?.description && (
                        <div
                          className="text-muted small mt-1"
                          style={{ textTransform: "capitalize" }}
                        >
                          {product?.description}
                        </div>
                      )}
                    </div>
                  </div>
                </Card.Header>

                <Card.Body className="pt-0">
                  <Row className="g-3">
                    {productPriceChanges.map((entry, idx) => {
                      const globalIndex = priceChanges.findIndex(
                        (p) =>
                          p.raw_sku_id === entry.raw_sku_id &&
                          p.from_date === entry.from_date
                      );

                      const formatDate = (dateStr) => {
                        const d = new Date(dateStr);
                        const day = String(d.getDate()).padStart(2, "0");
                        const month = String(d.getMonth() + 1).padStart(2, "0");
                        const year = d.getFullYear();
                        return `${month}/${day}/${year}`;
                      };

                      const getPreviousDate = (dateStr) => {
                        const d = new Date(dateStr);
                        d.setDate(d.getDate() - 1);
                        return formatDate(d.toISOString().split("T")[0]);
                      };

                      return (
                        <Col xl={4} lg={6} md={6} key={idx}>
                          <Card className="h-100 border shadow-none">
                            <Card.Body>
                              <div className="d-flex justify-content-between align-items-start mb-3">
                                <div>
                                  <Badge bg="primary" className="mb-2">
                                    Year {idx + 1}
                                  </Badge>
                                  <div className="fw-semibold">
                                    {formatDate(entry.from_date)} -{" "}
                                    {getPreviousDate(entry.to_date)}
                                  </div>
                                </div>
                              </div>

                              <Row className="g-3">
                                <Col sm={6}>
                                  <Form.Group>
                                    <Form.Label className="small fw-semibold text-muted">
                                      Customer Price
                                    </Form.Label>
                                    <InputGroup>
                                      <InputGroup.Text>$</InputGroup.Text>
                                      <Form.Control
                                        type="number"
                                        step="any"
                                        value={entry.customer_price}
                                        onChange={(e) =>
                                          handlePriceChange(
                                            globalIndex,
                                            "customer_price",
                                            e.target.value
                                          )
                                        }
                                        required
                                      />
                                    </InputGroup>
                                  </Form.Group>
                                </Col>

                                <Col sm={6}>
                                  <Form.Group>
                                    <Form.Label className="small fw-semibold text-muted">
                                      Aspetto Price
                                    </Form.Label>
                                    <InputGroup>
                                      <InputGroup.Text>$</InputGroup.Text>
                                      <Form.Control
                                        type="number"
                                        step="any"
                                        value={entry.aspetto_price}
                                        onChange={(e) =>
                                          handlePriceChange(
                                            globalIndex,
                                            "aspetto_price",
                                            e.target.value
                                          )
                                        }
                                        required
                                      />
                                    </InputGroup>
                                  </Form.Group>
                                </Col>
                              </Row>
                            </Card.Body>
                          </Card>
                        </Col>
                      );
                    })}
                  </Row>
                </Card.Body>
              </Card>
            );
          })
        )}
      </Modal.Body>

      <Modal.Footer className="">
        <Button
          type="button"
          variant="light"
          onClick={() => setShow({ show: false })}
        >
          Cancel
        </Button>

        <Button type="submit" variant="primary" disabled={notesLoading}>
          {notesLoading ? "Saving..." : "Save Price Changes"}
        </Button>
      </Modal.Footer>
    </Form>
  </Modal>
);
}
export default PriceChangesModal;